import { type PopoverProps, Popover as AntdPopover } from 'antd';

export const Popover = (props: PopoverProps) => (
  <AntdPopover arrow={{ pointAtCenter: true }} {...props} />
);
